import { Controller } from "react-hook-form";

import type { BaseQuestionProps, QuestionOption } from "../types";

import { FieldsetSingleChoice } from "./FieldsetSingleChoice";
import { IndexedOption } from "./IndexedOption";

type SingleChoiceQuestionProps = {
  options: QuestionOption[];
} & BaseQuestionProps;

export function SingleChoiceQuestion({
  control,
  errors,
  label,
  name,
  options,
  questionNumber,
}: SingleChoiceQuestionProps) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <FieldsetSingleChoice
          data-field-name={name}
          errorMessage={errors[name]?.message as string}
          isInvalid={!!errors[name]}
          label={label}
          onChange={field.onChange}
          questionNumber={questionNumber}
          value={field.value as string}
        >
          {options.map((option, idx) => (
            <IndexedOption
              index={option.index || String(idx + 1)}
              key={option.value}
              label={option.label}
              value={option.value}
            />
          ))}
        </FieldsetSingleChoice>
      )}
    />
  );
}
